import { Channel } from '@at/consumer-web-types';
const mapChannelFromAlternatives = (channel) => {
    const c = channel.toLowerCase().replace(/^profile /, '');
    switch (c) {
        case 'car':
        case 'profile cars':
        case 'cars':
            return Channel.cars;
        case 'van':
        case 'profile vans':
        case 'vans':
            return Channel.vans;
        case 'bike':
        case 'profile bikes':
        case 'bikes':
            return Channel.bikes;
        case 'motorhome':
        case 'profile motorhomes':
        case 'motorhomes':
            return Channel.motorhomes;
        case 'caravan':
        case 'profile caravans':
        case 'caravans':
            return Channel.caravans;
        case 'truck':
        case 'trucks':
            return Channel.trucks;
        case 'plant':
        case 'plant-machinary':
            return Channel.plant;
        case 'farm':
        case 'farm-machinary':
            return Channel.farm;
        case 'cycle':
        case 'cycles':
        case 'profile cycles':
            return Channel.cycles;
    }
};
const convertChannel = (c) => {
    if (!c)
        return undefined;
    for (const channel in Channel) {
        if (c === channel)
            return channel;
    }
    const a = mapChannelFromAlternatives(c);
    if (a)
        return a;
};
export { convertChannel };
